(() => {
  'use strict';

  const HISTORY_KEY = '__merlonsMobileMenu';
  const MOBILE_QUERY = '(max-width: 767px)';
  const MAX_RESTORE_ATTEMPTS = 40;
  let restoreApplied = false;
  let restoreTimer = 0;

  const labelMobileMenuControls = () => {
    const menu = document.querySelector('#canvas-main-menu');
    if (!menu) return;

    menu.querySelectorAll('.mm-next:not([aria-label]), .mm-prev:not([aria-label])').forEach((control) => {
      const item = control.closest('li, .mm-navbar');
      const textSource = control.nextElementSibling ||
        (item && item.querySelector('a:not(.mm-next):not(.mm-prev), .mm-title, span'));
      const label = textSource && textSource.textContent
        ? textSource.textContent.replace(/\s+/g, ' ').trim()
        : '';
      if (label) control.setAttribute('aria-label', label);
    });
  };

  const observeMobileMenuControls = () => {
    const drawer = document.querySelector('#mobile_menu');
    if (!drawer || typeof window.MutationObserver !== 'function') {
      labelMobileMenuControls();
      return;
    }

    labelMobileMenuControls();
    const observer = new MutationObserver(labelMobileMenuControls);
    observer.observe(drawer, { childList: true, subtree: true });
    window.setTimeout(() => {
      labelMobileMenuControls();
      observer.disconnect();
    }, 5000);
  };

  const currentHistoryState = () => {
    const state = window.history && window.history.state;
    return state && typeof state === 'object' && !Array.isArray(state) ? { ...state } : {};
  };

  const replaceMenuHistoryState = (snapshot) => {
    if (!window.history || typeof window.history.replaceState !== 'function') return;

    try {
      const nextState = currentHistoryState();
      if (snapshot) {
        nextState[HISTORY_KEY] = snapshot;
      } else {
        delete nextState[HISTORY_KEY];
      }
      window.history.replaceState(
        Object.keys(nextState).length ? nextState : null,
        document.title,
        window.location.href
      );
    } catch (error) {
      // Navigation must remain available if a browser refuses a history update.
    }
  };

  const readMenuHistoryState = () => {
    const snapshot = window.history && window.history.state && window.history.state[HISTORY_KEY];
    return snapshot && typeof snapshot === 'object' ? snapshot : null;
  };

  const normalizedInternalHref = (href) => {
    try {
      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return '';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return '';
    }
  };

  const isCollectionNavigationLink = (link) => {
    if (!link || !link.closest('#canvas-main-menu') || link.classList.contains('mm-next')) return false;
    const target = normalizedInternalHref(link.href);
    if (!target || target === normalizedInternalHref(window.location.href)) return false;

    try {
      const pathname = new URL(link.href, window.location.href).pathname;
      return /\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/|$)/i.test(pathname);
    } catch (error) {
      return false;
    }
  };

  const activeMenuPanel = (menu) =>
    menu.querySelector('.mm-panel.mm-opened:not(.mm-subopened)') ||
    menu.querySelector('.mm-panel.mm-opened');

  const collectMenuSnapshot = (link) => {
    const drawer = document.querySelector('#mobile_menu');
    const menu = document.querySelector('#canvas-main-menu');
    const panel = menu ? activeMenuPanel(menu) : null;
    if (!drawer || !menu || !drawer.classList.contains('act')) return null;

    return {
      version: 1,
      open: true,
      sourceHref: normalizedInternalHref(window.location.href),
      selectedHref: normalizedInternalHref(link.href),
      panelId: panel ? panel.id : '',
      panelScrollTop: panel ? Math.max(0, Math.round(panel.scrollTop)) : 0
    };
  };

  const persistMenuForNavigation = (link) => {
    const snapshot = collectMenuSnapshot(link);
    if (snapshot) replaceMenuHistoryState(snapshot);
  };

  const clearMenuHistoryState = () => {
    restoreApplied = false;
    replaceMenuHistoryState(null);
  };

  const isBackForwardRestore = (event) => {
    if (event && event.persisted) return true;
    const navigation = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType('navigation')[0]
      : null;
    if (navigation && navigation.type) return navigation.type === 'back_forward';
    return window.performance && window.performance.navigation
      ? window.performance.navigation.type === 2
      : false;
  };

  const findSavedLink = (menu, href) => {
    if (!href) return null;
    return Array.from(menu.querySelectorAll('a[href]')).find(
      (link) => !link.classList.contains('mm-next') && normalizedInternalHref(link.href) === href
    ) || null;
  };

  const openDrawerChrome = () => {
    const drawer = document.querySelector('#mobile_menu');
    const trigger = document.querySelector('#show-megamenu');
    const overlay = document.querySelector('.sidebar-overlay');
    if (!drawer || !trigger) return false;

    document.querySelectorAll('#mobile_search, .mobile-btn_search, #mobile_search .search_overlay')
      .forEach((element) => element.classList.remove('act'));
    drawer.classList.add('act');
    trigger.classList.add('act');
    trigger.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('act');
    document.body.style.overflow = 'hidden';
    return true;
  };

  const restoreMenuSnapshot = (snapshot) => {
    const menu = document.querySelector('#canvas-main-menu');
    if (!menu || !menu.classList.contains('mm-menu')) return false;

    const selectedLink = findSavedLink(menu, snapshot.selectedHref);
    const savedPanel = snapshot.panelId ? document.getElementById(snapshot.panelId) : null;
    const panel = (selectedLink && selectedLink.closest('.mm-panel')) ||
      (savedPanel && menu.contains(savedPanel) ? savedPanel : null);
    const api = window.jQuery ? window.jQuery(menu).data('mmenu') : null;
    if (!panel || !api || typeof api.openPanel !== 'function') return false;

    api.openPanel(window.jQuery(panel), false);
    if (selectedLink && typeof api.setSelected === 'function') {
      api.setSelected(window.jQuery(selectedLink).closest('li'));
    }
    if (!openDrawerChrome()) return false;

    window.requestAnimationFrame(() => {
      panel.scrollTop = Math.max(0, Number(snapshot.panelScrollTop) || 0);
    });
    return true;
  };

  const scheduleMenuRestore = (event) => {
    if (restoreApplied || !window.matchMedia(MOBILE_QUERY).matches || !isBackForwardRestore(event)) return;
    const snapshot = readMenuHistoryState();
    if (
      !snapshot ||
      !snapshot.open ||
      snapshot.sourceHref !== normalizedInternalHref(window.location.href) ||
      !document.body.classList.contains('template-index')
    ) return;

    window.clearTimeout(restoreTimer);
    let attempts = 0;
    const tryRestore = () => {
      attempts += 1;
      if (restoreMenuSnapshot(snapshot)) {
        restoreApplied = true;
        return;
      }
      if (attempts < MAX_RESTORE_ATTEMPTS) {
        restoreTimer = window.setTimeout(tryRestore, 50);
      }
    };
    tryRestore();
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target
      : (event.target && event.target.parentElement);
    if (!target) return;

    const link = target.closest('a[href]');
    if (
      document.body.classList.contains('template-index') &&
      window.matchMedia(MOBILE_QUERY).matches &&
      isCollectionNavigationLink(link)
    ) {
      persistMenuForNavigation(link);
      return;
    }

    const drawer = document.querySelector('#mobile_menu');
    if (!drawer || !drawer.classList.contains('act')) return;
    if (
      target.closest('#show-megamenu') ||
      target.closest('.sidebar-overlay') ||
      target.closest('.mobile-btn_search')
    ) {
      clearMenuHistoryState();
    }
  }, true);

  window.addEventListener('pageshow', scheduleMenuRestore);
  document.addEventListener('merlons:mobile-menu-close', clearMenuHistoryState);
  document.addEventListener('DOMContentLoaded', () => {
    observeMobileMenuControls();
    scheduleMenuRestore();
  });
})();
